import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

export const StatCounter = ({ value, suffix = "", decimals = 0, testid }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const duration = 1600;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      setDisplay(value * eased);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);

  const formatted = decimals > 0
    ? display.toFixed(decimals).replace(".", ",")
    : Math.round(display).toLocaleString("fr-FR");

  return (
    <span ref={ref} data-testid={testid} className="tabular-nums">
      {formatted}{suffix}
    </span>
  );
};
